import React from 'react'
import { ThemeProvider } from '@deseretbook/react-ui'
import Benefit from './Benefit'

const BenefitsPage = ({ description, imageProps }) => (
  <ThemeProvider theme={{ palette: { primary: '#89955d' } }}>
    <div />
  </ThemeProvider>
)

export default BenefitsPage
